import React from "react"
import CurrencyContext from "../../context/CurrencyContext"
import Pricing from "../ui/Pricing"
import NavLink from "../NavLink"
import { useStaticQuery, graphql } from "gatsby"

const ResellerHostingBlock = () => {
  const allData = useStaticQuery(graphql`
    query {
      allProductsJson(filter: { pid: { eq: 79 } }) {
        edges {
          node {
            pid
            name
            description
            pricing {
              INR {
                prefix
                suffix
                monthly
                annually
              }
              MYR {
                prefix
                suffix
                monthly
                annually
              }
              SGD {
                prefix
                suffix
                monthly
                annually
              }
              USD {
                prefix
                suffix
                monthly
                annually
              }
              GBP {
                prefix
                suffix
                monthly
                annually
              }
            }
          }
        }
      }
    }
  `)
  const data = allData.allProductsJson.edges
  return (
    <CurrencyContext.Consumer>
      {(context) => {
        return (
          <div className="col-12 col-md-4 mb-2">
            {data.map((item, index) => (
              <div key={index} className="card">
                <div className="card-body">
                  <h3 className="card-title mb-0 fs-20">Reseller Hosting</h3>
                  <div className="small-text mb-3">Host Multiple Domains</div>
                  <div className="card-text">
                    <div className="fw-bolder">Begin at just</div>
                    <div className="fs-32 fw-bolder mb-3">
                      <Pricing
                        CurrencyPrefix={item.node.pricing}
                        pricing={item.node.pricing}
                        productID={item.node.pid}
                      />
                    </div>
                  </div>
                  <NavLink
                    to="/reseller/linux-reseller-hosting/"
                    className="stretched-link btn btn-outline-dark"
                  >
                    Reseller Hosting
                  </NavLink>
                </div>
              </div>
            ))}
          </div>
        )
      }}
    </CurrencyContext.Consumer>
  )
}

export default ResellerHostingBlock
